export const denDocs = {
  name: 'den',
  category: 'Fraction',
  syntax: ['den(x)'],
  description: 'Get the denominator of a fraction.',
  examples: ['den(fraction(2, 3))', 'den(fraction(5, 8))'],
  seealso: ['num', 'fraction']
}
